export enum ADMIN_ACTIVITY_ASSET_TYPES {
  companies = 'navigation.tabs.companies',
  elds =  'navigation.tabs.elds',
  gpss = 'navigation.tabs.gpss',
  accessories = 'navigation.tabs.accessories',
  cameras = 'navigation.tabs.cameras'
}